import mod from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./project.detail.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./project.detail.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./src/views/project/project.detail.vue?vue&type=script&lang=js&
// module id = 774
// module chunks = 8